<template>
  <transition name="modal-fade">
    <div v-if="show" class="inadimplente-overlay">
      <div class="inadimplente-modal">

        <div class="inadimplente-modal__icon-wrap">
          <span class="material-symbols-outlined inadimplente-modal__icon">payments</span>
        </div>

        <h2 class="inadimplente-modal__title">Acesso Limitado</h2>
        <p class="inadimplente-modal__subtitle">
          Seu acesso às funcionalidades de transporte está temporariamente bloqueado
          devido à existência de pendências financeiras.
        </p>

        <div class="inadimplente-modal__info">
          <span class="material-symbols-outlined">info</span>
          <p>Procure um administrador para realizar a regularização do pagamento.</p>
        </div>

        <div class="inadimplente-modal__actions">
          <button class="inadimplente-modal__btn inadimplente-modal__btn--primary" @click="$emit('close')">
            Entendi
          </button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script setup>
defineProps({
  show: { type: Boolean, default: false },
})
defineEmits(['close'])
</script>

<style scoped>
.inadimplente-overlay {
  position: fixed; inset: 0; z-index: 500;
  background: rgba(0,0,0,0.6);
  display: flex; align-items: center; justify-content: center;
  padding: 1rem;
}
.inadimplente-modal {
  background: #fff; border-radius: 1.25rem;
  width: min(420px, 100%);
  box-shadow: 0 24px 64px rgba(0,0,0,0.2);
  display: flex; flex-direction: column;
  align-items: center; text-align: center;
  padding: 2rem 1.75rem;
  gap: 0.875rem;
}

.inadimplente-modal__icon-wrap {
  width: 72px; height: 72px; border-radius: 50%;
  background: #fef3c7;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 0.25rem;
}
.inadimplente-modal__icon { font-size: 36px; color: #d97706; }

.inadimplente-modal__title {
  font-size: 1.25rem; font-weight: 800;
  color: #0f172a; margin: 0;
}
.inadimplente-modal__subtitle {
  font-size: 0.875rem; color: #64748b;
  margin: 0; line-height: 1.55;
}

.inadimplente-modal__info {
  display: flex; align-items: flex-start; gap: 0.5rem;
  width: 100%;
  background: #fffbeb; border: 1px solid #fde68a;
  border-radius: 0.75rem; padding: 0.875rem 1rem;
  text-align: left;
}
.inadimplente-modal__info .material-symbols-outlined {
  font-size: 18px; color: #d97706; flex-shrink: 0; margin-top: 1px;
}
.inadimplente-modal__info p {
  font-size: 0.8rem; color: #92400e;
  margin: 0; line-height: 1.5;
}

.inadimplente-modal__actions {
  display: flex; gap: 0.75rem; width: 100%; margin-top: 0.25rem;
}
.inadimplente-modal__btn {
  flex: 1; border: none; border-radius: 0.625rem;
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem; font-weight: 600; cursor: pointer;
  transition: background 0.15s;
}
.inadimplente-modal__btn--primary {
  background: #d97706; color: #fff;
}
.inadimplente-modal__btn--primary:hover { background: #b45309; }

[data-theme="dark"] .inadimplente-modal {
  background: var(--color-bg-card, #0D1B3E);
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
}
[data-theme="dark"] .inadimplente-modal__title { color: #fff; }
[data-theme="dark"] .inadimplente-modal__subtitle { color: #94a3b8; }
[data-theme="dark"] .inadimplente-modal__info {
  background: rgba(217,119,6,0.1); border-color: rgba(217,119,6,0.3);
}
[data-theme="dark"] .inadimplente-modal__info p { color: #fcd34d; }

.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity 0.25s ease; }
.modal-fade-enter-from,  .modal-fade-leave-to      { opacity: 0; }
</style>
